import '../../capabilities/registry';
import { registerDeployPlugin } from '../../core/registry';
import { registerResourceConfigs } from '../../platform/resource-watch';
import { registerSkuModuleMeta } from '../../platform/scene-layout/moduleMetaRegistry';
import { bareMetalHeadless } from './headless';
import { BARE_METAL_RESOURCE_CONFIGS, BARE_METAL_SKU_MODULE_META } from './resourceConfigs';

registerSkuModuleMeta('BareMetal', BARE_METAL_SKU_MODULE_META);
registerResourceConfigs('BareMetal', BARE_METAL_RESOURCE_CONFIGS);

registerDeployPlugin({
  headless: bareMetalHeadless,
  loadUi: () =>
    import('./ui').then((m) => ({
      ResourceEditor: m.BareMetalResourceEditor,
      ResourcePreview: m.BareMetalResourcePreview,
    })),
});

export { bareMetalFromForm, buildBareMetalDeliveryMetadata, buildBareMetalOrderDeliveryMetadata } from './headless';
export type {
  BuildBareMetalDeliveryMetadataContext,
  BuildBareMetalOrderDeliveryMetadataContext,
  BareMetalDeliveryMetadata,
} from './headless';
export { buildBareMetalFreshDisplayConfig } from './display';
export { buildBareMetalMergedDisplayConfig } from './display/mergeDisplayConfig';
export {
  BM_PRODUCT_CARD_EXCLUDED_DISPLAY_IDS,
  filterBmProductCardDisplayConfig,
  finalizeBmSubmitDisplayConfig,
} from './display/productCard';
export { BARE_METAL_FIELD_KEYS } from './fields';
export type { BareMetalFieldKey } from './fields';
export { hydrateBareMetalDetailToForm } from './hydrateFromApiDetail';
export type { BareMetalLinkagePropsMap } from './linkage';
export { BARE_METAL_CAPABILITIES } from './capabilities';
export { BARE_METAL_MODULE_MAP, BARE_METAL_MODULES } from './modules';
export { BARE_METAL_RESOURCE_CONFIGS, BARE_METAL_SKU_MODULE_META, bareMetalNodeResource } from './resourceConfigs';
export {
  BARE_METAL_ALL_MODULES,
  BARE_METAL_DIRECT_CREATE_STEPS,
  BARE_METAL_DIRECT_MERGED_MODULES,
  BARE_METAL_ORDER_MODULES,
  BARE_METAL_SCENES,
  BARE_METAL_SKU_MODULE_LIST,
  BARE_METAL_SKU_MODULES,
  buildBareMetalDirectResourceModulesFromForm,
  filterBareMetalDirectMergedModules,
  filterBareMetalSkuModules,
  isBareMetalSkuModuleKey,
  resolveBareMetalSceneConfig,
} from './scenes';
export type { BareMetalModuleKey, BareMetalSkuModuleKey } from './scenes';
export { buildBareMetalSkuCapabilityOptions } from './skuCapabilityOptions';
export { resetBareMetalSkuModuleFields } from './skuModuleReset';
export { resolveBareMetalSkuPreviewExtraWatchFields } from './skuPreviewWatch';
export {
  BARE_METAL_ORDER_INNER_ROOT_WATCH_FIELDS,
  BARE_METAL_ORDER_PREVIEW_EXTRA_WATCH_FIELDS,
  resolveBareMetalOrderInnerRootWatchFields,
  resolveBareMetalOrderPreviewExtraWatchFields,
} from './orderPreviewWatch';
export { BareMetalResourceEditor, useBareMetalDeployFormLinkage } from './ui/ResourceEditor';
export type { BareMetalResourceEditorProps } from './ui/ResourceEditor';
export { BareMetalResourcePreview } from './ui/ResourcePreview';
export type { BareMetalResourcePreviewProps } from './ui/ResourcePreview';
